import React from 'react';
import { render, unmount } from 'rc-util/lib/React/render';
// import ComponentCodebox from './components/Codebox';
import Modal from 'react-modal';
import './index.less';
import PageChoose from './components/PageChoose';
import PageAnswer from './components/PageAnswer';
import { inApp } from "@/common/js/constant";
import { query, select, answer} from './services';
import { RiskFactor } from '@/common/js/constant';
import CryptoJS from 'crypto-js';
import { ERROR_MESSAGE } from '@/utils/request';
import App from '@/utils/app';

// 风控核验sdk版本
export const RISK_SDK_VERSION: string = '1.6';
const bridge = window.Fusion && window.Fusion.loadModule("SofiBridgeModule");

// 
class RiskVerify implements IRiskVerify {
  constructor(service?: IRiskService) {
    this.service = service || { query, select, answer };
    this.pageFragment = document.createDocumentFragment();
    this.popupFragment = document.createDocumentFragment();
  }
  service: IRiskService;
  // list dom
  pageFragment: DocumentFragment;
  // popup dom
  popupFragment: DocumentFragment;
  // 提供给passport sdk调用
  async login(sessionId: RiskToken): Promise<RiskVerifyResult> {
    // 查询风控信息
    const riskDetail = await this.service.query({ sessionId, verifySdkVersion: RISK_SDK_VERSION, passportToken: ''});
    // 调用风控核验
    return this.verify({sessionId, ...riskDetail});
  }
  // 业务侧调用
  async verify(detail: PageRiskDetail & { sessionId: RiskToken }): Promise<RiskVerifyResult> {

    try {
      // 等待用户选择核验方式
      let verifyMethod: RiskFactor
      // 是否使用核验列表
      if (detail.isUseList) {
        verifyMethod = await new Promise<RiskFactor>((resolve, reject) => {
          // 渲染核验列表
          render(
            <Modal className='sdk-risk-verify' isOpen  preventScroll={ true } style={{overlay: { zIndex: 999 }}}>
              <PageChoose title={ detail.title } description={ detail.subTitle } options={ detail.verifyList }  onChoose={ resolve } /> 
            </Modal>, 
            this.pageFragment
          );
        });
      } else {
        // 不使用列表默认第一个核验方式
        verifyMethod = detail?.verifyList[0]?.name;
      }
      // 不存在核验方式 跳出
      if(!verifyMethod) {
        // 卸载用户选择页面
        unmount(this.pageFragment);
        return new Promise(() => void 0);
      };
      // 获取token临时方案，token治理上线后移除
      const token: string = await new Promise(( resolve ) => {
        if (inApp) {
          bridge.sfGetSofipoTicket(resolve);
        } else {
          resolve('');
        }
      });
      // 触发核验
      const handleTrigger = (currentVerifyType: RiskFactor) => {
        return this.service.select({
          sessionId: detail.sessionId,
          passportToken: token ||'',
          verifySdkVersion: RISK_SDK_VERSION,
          verifyType: verifyMethod,
          currentVerifyType,
        });
      }

      // 用户提交答案
      const handleSubmit = (answer: string, currentVerifyType: RiskFactor, triggerId: string) => {
        // curp号需要加密
        if(currentVerifyType === RiskFactor.CURP_VERIFY) {
          // answer = 'f020272c938ba0a213d31613fd5a1a8b053c693d489551f8b24e900db43d6873';
          answer = CryptoJS.SHA256(answer).toString();
        }
        return new Promise<RiskVerifyResult>(async (resolve, reject) => {
          this.service.answer({
            answer,
            sessionId: detail.sessionId,
            verifySdkVersion: RISK_SDK_VERSION,
            verifyType: verifyMethod,
            passportToken: token||'',
            triggerId: triggerId,
            currentVerifyType: currentVerifyType
          }).then(resolve, reject);
        });
      }
      let verifyResult: RiskVerifyResult; 
      let currentVerifyIndex: number = 0;
      const verifyList = verifyMethod.split('+') as RiskFactor[];
      let currentVerifyType: RiskFactor = verifyList[currentVerifyIndex];
      while(true) {
        // 等待用户输入答案
        verifyResult = await new Promise<RiskVerifyResult>((resolve, reject) => {
          const handleSwitch = (verifyType: RiskFactor) => {
            currentVerifyType = verifyType;
            resolve(verifyResult);
          }
           // 渲染核验弹窗
          render(<Modal className='sdk-risk-verify' isOpen  preventScroll={ true } style={{overlay: { zIndex: 999, backgroundColor: 'rgba(0, 0, 0, 0.6)' }}}>
            <PageAnswer 
              type={ currentVerifyType }
              onSubmit={ handleSubmit }
              onTrigger={ handleTrigger }
              onSuccess={ resolve }
              onCancel={ reject }
              onSwitch={ handleSwitch }
            />
          </Modal>, this.popupFragment);
        });
        // 卸载核验弹窗
        await unmount(this.popupFragment);
        // 
        if(verifyResult === undefined) {
          continue;
        }
        // 下一个核验
        currentVerifyType = verifyList[ ++currentVerifyIndex ];
        if(currentVerifyType) {
          continue;
        }
        break;
      }
      // 成功后卸载
      unmount(this.pageFragment);
      // 核验成功
      return Promise.resolve(verifyResult);

    } catch (e) {
      unmount(this.popupFragment);
      // 用户取消并存在核验列表的情况下 再次打开核验列表
      if(e === true && detail.isUseList) {
        return this.verify(detail);
      }
    }
    // 卸载页面
    unmount(this.pageFragment);
    unmount(this.popupFragment);
    // 核验失败
    return Promise.reject({message: ERROR_MESSAGE.RiskVerifyFailed});
  }
}


export default RiskVerify;